import axios from "axios";
import { toast } from "view/component/Alert";
import Auth from "./auth";
/**
 *
 * Class untuk manajemen API
 * @class API
 */

//''
//'http://smartsisfomas.simkes.id:1235/'

class API {
  service = axios.create({
    baseURL: process.env.REACT_APP_SERVER_URL,
    responseType: "json",
    headers: {
      "Content-Type": "application/json",
    },
  });
  token = localStorage.getItem("accessToken");
  header = {
    Authorization: this.token,
  };

  async fetch({ url, data = "", method }) {
    try {
      this.service.interceptors.request.use(
        (config) => {
          const token = localStorage.getItem("accessToken");
          if (token) {
            config.headers["Authorization"] = token;
          }
          // config.headers['Content-Type'] = 'application/json';
          return config;
        },
        (error) => {
          Promise.reject(error);
        }
      );
      const res = await this.service({
        url,
        headers: this.header,
        data,
        method,
      });
      return res.data;
    } catch (error) {
      throw error.response;
    }
  }

  async delete(url) {
    try {
      this.service.interceptors.request.use(
        (config) => {
          const token = localStorage.getItem("accessToken");
          if (token) {
            config.headers["Authorization"] = token;
          }
          // config.headers['Content-Type'] = 'application/json';
          return config;
        },
        (error) => {
          Promise.reject(error);
        }
      );
      const res = await this.service.delete(url, {
        headers: this.header,
      });
      return res.data;
    } catch (error) {
      return error.response;
    }
  }

  async get(url) {
  const auth = new Auth();
    try {
      this.service.interceptors.request.use(
        (config) => {
          const token = localStorage.getItem("accessToken");
          if (token) {
            config.headers["Authorization"] = token;
          }
          // config.headers['Content-Type'] = 'application/json';
          return config;
        },
        (error) => {
          Promise.reject(error);
        }
      );
      const res = await this.service.get(url, {
        headers: this.header,
      });
      return res.data;
    } catch (error) {
      if (error.response?.data?.status == 'sesi habis silahkan login lagi') {
        toast({text:'sesi habis silahkan login lagi', status:'error'});
        // console.log("Provided token is expired.");
        auth.logout();
      }
      return error.response;
    }
  }
  async get1(url, data) {
    try {
      this.service.interceptors.request.use(
        (config) => {
          const token = localStorage.getItem("accessToken");
          if (token) {
            config.headers["Authorization"] = token;
          }
          // config.headers['Content-Type'] = 'application/json';
          return config;
        },
        (error) => {
          Promise.reject(error);
        }
      );
      const res = await this.service.get(url, data, {
        headers: this.header,
      });
      return res.data;
    } catch (error) {
      return error.response;
    }
  }

  async getblob(url) {
    try {
      this.service.interceptors.request.use(
        (config) => {
          const token = localStorage.getItem("accessToken");
          if (token) {
            config.headers["Authorization"] = token;
            // config.responseType = 'blob';
          }
          // config.headers['Content-Type'] = 'application/json';
          return config;
        },
        (error) => {
          Promise.reject(error);
        }
      );
      const res = await this.service.get(url, {
        headers: this.header,
        responseType: "blob",
      });
      return res.data;
    } catch (error) {
      return error.response;
    }
  }

  async postBlob(url, data) {
    try {
      this.service.interceptors.request.use(
        (config) => {
          const token = localStorage.getItem("accessToken");
          if (token) {
            config.headers["Authorization"] = token;
          }
          // config.headers['Content-Type'] = 'application/json';
          return config;
        },
        (error) => {
          Promise.reject(error);
        }
      );
      const res = await this.service.post(url, data, {
        headers: this.header,
        responseType: "blob",
      });
      return res.data;
    } catch (error) {
      return error.response;
    }
  }

  async post(url, data) {
    try {
      this.service.interceptors.request.use(
        (config) => {
          const token = localStorage.getItem("accessToken");
          if (token) {
            config.headers["Authorization"] = token;
          }
          // config.headers['Content-Type'] = 'application/json';
          return config;
        },
        (error) => {
          Promise.reject(error);
        }
      );
      const res = await this.service.post(url, data, {
        headers: this.header,
      });
      return res.data;
    } catch (error) {
      return error.response;
    }
  }

  async put(url, data) {
    try {
      this.service.interceptors.request.use(
        (config) => {
          const token = localStorage.getItem("accessToken");
          if (token) {
            config.headers["Authorization"] = token;
          }
          // config.headers['Content-Type'] = 'application/json';
          return config;
        },
        (error) => {
          Promise.reject(error);
        }
      );
      const res = await this.service.put(url, data, {
        headers: this.header,
      });
      return res.data;
    } catch (error) {
      return error.response;
    }
  }

  multiPost(dataArray) {
    return Promise.all(
      dataArray.map((data) => {
        if (!data.data) return null;
        return this.service({
          url: data.url,
          data: data.data,
          headers: this.header,
          method: "post",
          transformResponse: [
            (responseData) => {
              return { ...responseData, name: data.name };
            },
          ],
        })
          .then((response) => {
            return response.data;
          })
          .catch((error) => {
            return error.response.data;
          });
      })
    ).then((responses) => {
      let isSuccess = true;
      const newResponses = {};
      const cleanResponses = responses.filter((response) => response !== null);

      cleanResponses.forEach((val, i) => {
        if (val.code !== 200) isSuccess = false;
        newResponses[val.name] = { ...val };
      });

      return { ...newResponses, isSuccess: isSuccess };
    });
  }

  async getAll(array) {
    let url = [];
    array.map((urlGet) => {
      url.push(
        this.service.get(urlGet, {
          headers: this.header,
        })
      );
    });
    try {
      const data = axios
        .all(url)
        .then(
          axios.spread((...responses) => {
            // console.log(responses, 'ok')
            return responses;
          })
        )
        .catch((errors) => {
          // console.log(errors.response, 'errr')
          return errors?.response;
        });

      return data;
    } catch (error) {
      return error.response;
    }
  }
}

export default new API();
